import { ReleasesApi } from '@/state/api';
import { useAppSelector } from '@state';

export const useSelectedReleaseContext = () => {
  const selectedRelease = useAppSelector((state) => state.release.selectedRelease);
  const releaseId = selectedRelease?.id;

  const { data: release, isLoading: isLoadingRelease } =
    ReleasesApi.Api.useGetReleaseByIdQuery(
      { releaseId: releaseId as number },
      { skip: !releaseId },
    );

  return {
    selectedRelease,
    release,
    releaseId: release?.id ?? releaseId ?? null,
    projectId: release?.project ?? null,
    isLoadingRelease,
  };
};
